import clsx from 'clsx';
import ActionGroup from './ActionGroup';

const PageHeader = ({
  title,
  description,
  actions,
  eyebrow,
  className,
  titleClassName,
  stackActionsOnMobile = false,
}) => (
  <header
    className={clsx(
      'flex min-w-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between',
      className
    )}
  >
    <div className="min-w-0 flex-1">
      {eyebrow && (
        <div className="mb-1 text-sm font-medium text-primary-600 dark:text-primary-400">
          {eyebrow}
        </div>
      )}
      <h1
        className={clsx(
          'break-words text-2xl font-semibold text-light-text-primary dark:text-dark-text-primary sm:text-3xl',
          titleClassName
        )}
      >
        {title}
      </h1>
      {description && (
        <div className="mt-1 max-w-3xl break-words text-sm text-light-text-secondary dark:text-dark-text-secondary">
          {description}
        </div>
      )}
    </div>
    {actions && (
      <ActionGroup
        align="end"
        stackOnMobile={stackActionsOnMobile}
        className="w-full shrink-0 sm:w-auto"
      >
        {actions}
      </ActionGroup>
    )}
  </header>
);

export default PageHeader;
